import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MaterialBoolControl, StrictNumberInput } from 'shared/components/fields';
import { HeatingCircuit, Pump } from 'z3k-config';
import { DHWControlType } from 'console/climatic/utils/dhw-control-type';
import { Control } from 'shared/components/fields/control';
import { InputAdornment } from '@mui/material';
import { SettingCard } from 'z3k-settings/components/material-utils/settings-card';
import { useContext, useMemo } from 'react';
import { HeatingControlType } from 'console/climatic/setting-tabs/type';
import { useHeatingCircuitsItemState } from 'z3k-settings/climatic/heating-circuits-item/lib/useHeatingCircuitsItemState';
import { useConfigurationState } from 'z3k-settings/climatic/configuration/lib/useConfigurationState';
import { Z3KSettingsEditor } from 'z3k-settings/provider/types';
import { dhw_boiler_pump_id } from 'console/climatic/constants';
import { useEditingProps } from 'z3k-settings/components/utils/unpack-props';
export function PumpSettings() {
    const { circuit, circulation_pump_mode, dhw_use_circ_pump, boiler_pump_delay, circulation_pump_delay, circulation_pump_id, } = useHeatingCircuitsItemState();
    const { circuits, dhw } = useConfigurationState();
    const circuit_configuration = useMemo(() => circuits.find((circ) => circ.id == circuit.id), [circuit, circuits]);
    const isShowAlwaysWork = useMemo(() => !HeatingCircuit.isDHW(circuit) &&
        circuit_configuration?.control_type !== HeatingControlType.DIRECT, [circuit, circuit_configuration]);
    const isShowCN = useMemo(() => HeatingCircuit.isDHW(circuit), [circuit]);
    const dhw_selected = useMemo(() => dhw.find((setting) => setting.id == circuit.id), [circuit, dhw]);
    const dhw_control_type = useMemo(() => dhw_selected?.control_type, [dhw_selected]);
    const { config, replace_config } = useContext(Z3KSettingsEditor);
    const circulationDelayEditingProps = useEditingProps(circulation_pump_id, 'pumps', 'delay');
    const boilerDelayEditingProps = useEditingProps(dhw_boiler_pump_id, 'pumps', 'delay');
    return (_jsxs(SettingCard, { title: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u043D\u0430\u0441\u043E\u0441\u0430", children: [isShowAlwaysWork && (_jsx(MaterialBoolControl, { label: "\u041F\u043E\u0441\u0442\u043E\u044F\u043D\u043D\u0430\u044F \u0440\u0430\u0431\u043E\u0442\u0430 \u0426\u041D", value: circulation_pump_mode == Pump.Mode.ALWAYS_WORK, onChange: (checked) => {
                    const pump_mode = checked
                        ? Pump.Mode.ALWAYS_WORK
                        : Pump.Mode.BY_HEAT_REQUEST;
                    replace_config(Pump.get.modifyById(config, circulation_pump_id, (pump) => Pump.setMode(pump, pump_mode)));
                } })), isShowCN && (_jsx(MaterialBoolControl, { label: HeatingCircuit.isDHW(circuit)
                    ? 'Использовать насос рециркуляции ГВС'
                    : 'Использовать ЦН', value: dhw_use_circ_pump, onChange: (checked) => {
                    let new_config = config;
                    if (circuit.type === HeatingCircuit.Type.DHW) {
                        new_config = Pump.get.modifyById(config, circulation_pump_id, (pump) => Pump.setMode(pump, checked
                            ? Pump.Mode.ALWAYS_WORK
                            : Pump.Mode.BY_HEAT_REQUEST));
                    }
                    if (checked &&
                        !circuit.control_devices.includes(circulation_pump_id)) {
                        new_config = {
                            ...new_config,
                            heating_circuits: config.heating_circuits.map((item) => {
                                if (item.id === circuit.id) {
                                    return {
                                        ...item,
                                        control_devices: [
                                            ...circuit.control_devices,
                                            circulation_pump_id,
                                        ],
                                    };
                                }
                                return item;
                            }),
                        };
                    }
                    if (!checked &&
                        circuit.control_devices.includes(circulation_pump_id)) {
                        new_config = {
                            ...new_config,
                            heating_circuits: config.heating_circuits.map((item) => {
                                if (item.id === circuit.id) {
                                    return {
                                        ...item,
                                        control_devices: item.control_devices.filter((device_id) => device_id !==
                                            circulation_pump_id),
                                    };
                                }
                                return item;
                            }),
                        };
                    }
                    replace_config(new_config);
                } })), HeatingCircuit.isDHW(circuit) ? (dhw_control_type == DHWControlType.BOILER && (_jsx(Control, { label: "\u0412\u044B\u0431\u0435\u0433 \u043D\u0430\u0441\u043E\u0441\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0431\u043E\u0439\u043B\u0435\u0440\u0430", ...boilerDelayEditingProps, field: (input_props) => (_jsx(StrictNumberInput, { min: 0, max: 120, endAdornment: _jsx(InputAdornment, { position: "end", children: "\u043C\u0438\u043D" }), ...input_props })) }))) : (_jsx(Control, { label: "\u0412\u044B\u0431\u0435\u0433 \u043D\u0430\u0441\u043E\u0441\u0430", ...circulationDelayEditingProps, field: (input_props) => (_jsx(StrictNumberInput, { disabled: isShowAlwaysWork &&
                        circulation_pump_mode == Pump.Mode.ALWAYS_WORK, min: 0, max: 120, endAdornment: _jsx(InputAdornment, { position: "end", children: "\u043C\u0438\u043D" }), ...input_props })) }))] }));
}
